const supplierManagementPageStyle = {
  root: {
    flexGrow: 1,
    display: 'flex',
    height: '100%',
  },
  componentPanel: {
    marginRight: '100px',
  },
  margin: {
    margin: 1,
  },
  customCancelBookingContainer: {
    borderRadius: '10px',
    margin: '10 10 10 10',
    paddingTop: '15px',
    paddingLeft: '25px',
    paddingRight: '30px',
  },
  customCancelBookingHeader: {
    fontSize: 'var(--fs-18, 1.125rem)',
    fontWeight: '400',
  },
  customCancelBookingMessage: {
    fontSize: 'var(--fs-16, 1rem)',
  },
  customCancelBookingCancelButton: {
    fontSize: 'var(--fs-16, 1rem)',
  },
  customCancelBookingConfirmButton: {
    fontSize: 'var(--fs-16, 1rem)',
  },
}

export default supplierManagementPageStyle
